import createPermission from 'permissions/createPermission'

export const add = createPermission('unit.remarks.add')
export const remove = createPermission('unit.remarks.remove')

export default createPermission('unit.remarks.list')